<div class="filter-container">
  <div class="ag-filter-body filter-input" (keydown.enter)="applyFilter()">
    <input
      id="filter"
      type="text"
      placeholder="Filter..."
      aria-label="Filter Value"
      class="ag-input-field-input ag-text-field-input"
      [(ngModel)]="trademarkInputValue"
    />
  </div>
  <div>
    <mat-radio-group [(ngModel)]="selectedCondition" class="radio-group">
      @for (condition of filterConditions; track condition) {
      <mat-radio-button
        class="ag-radio-button ag-input-field ag-label join-operator"
        [value]="condition"
        color="primary"
        >{{ condition }}</mat-radio-button
      >
      }
    </mat-radio-group>
  </div>

  <div class="ag-filter-apply-panel">
    <button
      type="button"
      class="ag-standard-button ag-filter-apply-panel-button"
      (click)="clearFilter()"
    >
      Clear</button
    ><button
      type="button"
      class="ag-standard-button ag-filter-apply-panel-button"
      (click)="applyFilter()"
    >
      Apply
    </button>
  </div>
</div>
